import * as ActionTypes from "./faqActionType";

const initialState = {
    isLoading: false,
    isSaved: false,
    faqs: [],
};

export const faqReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_FAQ:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.GET_FAQ_FAILURE:
            return {
                ...state,
                isLoading: false,
            };

        case ActionTypes.GET_FAQ_SUCCESS:
            return {
                ...state,
                isLoading: false,
                faqs: action?.payload?.data || [],
            };

        default:
            return state;
    }
};
